import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger, CSSRulePlugin } from 'gsap/all';

export const useVideoSectionAnimation = (ref: React.RefObject<HTMLDivElement | null>) => {
  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger, CSSRulePlugin);

      const { current } = ref;
      if (!current) return;

      gsap.set([current.querySelector('h4'), current.querySelector('button')], {
        alpha: 0,
        y: 50,
      });
      const tl2 = gsap.timeline({
        defaults: {
          ease: 'power3.inOut',
        },
        scrollTrigger: {
          trigger: current,
          start: 'top center',
          end: 'bottom center',
          toggleActions: 'play none reverse reverse',
          markers: false,
        },
      });

      tl2
        .to(current.querySelector('.videoBackground'), {
          scale: 1,
        })
        .to(
          current.querySelector('.videoBackground'),
          {
            '--heightBg': '70%',
            duration: 1,
          },
          '-=0.75',
        );

      const tl = gsap.timeline({
        defaults: {
          ease: 'power3.inOut',
        },
        scrollTrigger: {
          trigger: current,
          start: 'top center',
          end: 'bottom center',
          toggleActions: 'play none none reverse',
          markers: false,
        },
      });

      tl.to(
        current.querySelector('h4'),
        {
          alpha: 1,
          duration: 1,
        },
        '-=0.2',
      )
        .to(current.querySelector('h4'), {
          y: 0,
          duration: 1,
        })
        .to(
          current.querySelector('button'),
          {
            y: 0,
            alpha: 1,
            duration: 1,
          },
          '-=0.75',
        );

      tl.timeScale(1.5);
    },
    { scope: ref },
  );
};
